
<p-confirmDialog />

<div class="card">
  <div class="card-content">
    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalTasksCount }}</span>
          <span class="stats-card-label">Total Tasks</span>
          <span class="stats-card-sublabel">All tasks</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-list"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeTasksCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveTasksCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalRecords }}</span>
          <span class="stats-card-label">Showing</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-filter"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatusFilter" (ngModelChange)="applyFilters()"
            [options]="statusFilterOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="serviceGroupFilter" class="filter-label">Service Group</label>
          <p-select id="serviceGroupFilter" [(ngModel)]="selectedServiceGroupFilter" (ngModelChange)="applyFilters()"
            [options]="serviceGroups" optionLabel="name" optionValue="id" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search service group..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
      </div>
      <div class="filter-bar-actions" *ngIf="hasActiveFilters()">
        <button type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <p-table
      [scrollable]="true"
      scrollHeight="flex"
      [value]="filteredTasks"
      [loading]="loading"
      [paginator]="true"
      [alwaysShowPaginator]="false"
      [rows]="rows"
      [totalRecords]="totalRecords"
      [first]="first"
      [rowsPerPageOptions]="rowsPerPageOptions"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} tasks"
      [tableStyle]="{ 'min-width': '100%' }"
      styleClass="p-datatable no-column-lines">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            Name
            <p-sortIcon field="name" />
          </th>
          <th pSortableColumn="description">
            Description
            <p-sortIcon field="description" />
          </th>
          <th pSortableColumn="serviceGroupId">
            Service Group
            <p-sortIcon field="serviceGroupId" />
          </th>
          <th style="width: 140px">Leave / Holiday only</th>
          <th class="th-actions">Actions</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-task>
        <tr [class.row-inactive]="task.isActive === false">
          <td class="td-truncate" [pTooltip]="task.name || '-'" tooltipPosition="top">{{ task.name }}</td>
          <td class="td-truncate td-description" [pTooltip]="(task.description || '-')" tooltipPosition="top">{{ task.description || '-' }}</td>
          <td class="td-truncate" [pTooltip]="getServiceGroupNames(task)" tooltipPosition="top">{{ getServiceGroupNames(task) }}</td>
          <td>
            <span *ngIf="task.isLeaveType" class="leave-type-badge">Yes</span>
            <span *ngIf="!task.isLeaveType">No</span>
          </td>
          <td class="table-cell-actions">
            <div class="table-actions-stack">
              <p-button
                [icon]="task.isActive ? 'pi pi-check-circle' : 'pi pi-times-circle'"
                [severity]="task.isActive ? 'success' : 'secondary'"
                [text]="true"
                (onClick)="toggleTaskStatus(task)"
                size="small"
                [pTooltip]="task.isActive ? 'Active' : 'Inactive'"
                tooltipPosition="top" />
              <p-button
                icon="pi pi-pencil"
                (onClick)="openEditDialog(task)"
                [text]="true"
                severity="info"
                size="small"
                pTooltip="Edit"
                tooltipPosition="top" />
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr class="table-empty-row">
          <td colspan="5" class="table-empty-cell">
            <div class="empty-state">
              <div class="empty-icon"><i class="pi pi-inbox"></i></div>
              <p class="empty-message">No tasks found</p>
              <p class="empty-description">Update filters or add a new task</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Task' : 'Edit Task'"
  [modal]="true" styleClass="dialog-md" [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">
      <div class="form-row">
        <div class="field" [class.field-invalid]="fieldTouched['name'] && !selectedTask.name.trim()">
          <label for="taskName">Name <span class="required-star">*</span></label>
          <input pInputText id="taskName" [(ngModel)]="selectedTask.name" placeholder="Enter task name" (blur)="fieldTouched['name'] = true" />
          <small class="field-error" *ngIf="fieldTouched['name'] && !selectedTask.name.trim()">Task name is required</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="taskDescription">Description</label>
          <textarea id="taskDescription" [(ngModel)]="selectedTask.description" rows="2"
            class="p-inputtext" placeholder="Enter task description"></textarea>
        </div>
      </div>
      <div class="form-row">
        <div class="field">
          <label for="taskServiceGroups">Service Groups</label>
          <p-multiSelect id="taskServiceGroups" [(ngModel)]="selectedTask.serviceGroupIds"
            [options]="serviceGroups" optionLabel="name" optionValue="id"
            placeholder="Select service groups" [filter]="true" filterPlaceholder="Search service group..."
            [showToggleAll]="true" [showClear]="true" display="chip"
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
          <small class="text-muted text-xs">You can select multiple service groups for this task type.</small>
        </div>
      </div>
      <div class="form-row">
        <div class="field flex align-items-center gap-2">
          <p-checkbox id="taskIsLeaveType" [(ngModel)]="selectedTask.isLeaveType"
            [binary]="true" inputId="taskIsLeaveType" />
          <label for="taskIsLeaveType" class="cursor-pointer text-sm">Leave / Holiday type only</label>
        </div>
      </div>
      <div class="form-row" *ngIf="dialogMode === 'edit'">
        <div class="field">
          <label>Status</label>
          <p-button [label]="selectedTask.isActive ? 'Active' : 'Inactive'"
            [severity]="selectedTask.isActive ? 'success' : 'secondary'" [outlined]="!selectedTask.isActive"
            (onClick)="selectedTask.isActive = !selectedTask.isActive" size="small" />
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Reset" icon="pi pi-refresh" (onClick)="resetTaskForm()" [text]="true" severity="secondary"
        styleClass="btn-form-reset" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveTask()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>
